export default "__VITE_ASSET__0AoTJr6T__"